import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Slider, Typography, TextField } from '@mui/material';
import BaseFilterPopover from './BaseFilterPopover';

const CustomSlider = styled(Slider)(() => ({
  color: '#52af77',
  height: 8,
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:hover, &.Mui-active': {
      boxShadow: 'inherit',
    },
  },
  '& .MuiSlider-valueLabel': {
    left: 'calc(-50% + 4px)',
  },
  '& .MuiSlider-track': {
    height: 8,
    borderRadius: 4,
  },
  '& .MuiSlider-rail': {
    height: 8,
    borderRadius: 4,
    opacity: 0.5,
  },
}));

export class SliderOptions {
  constructor(range, defaultRange) {
    this.range = range;
    this.defaultRange = defaultRange;
  }
}

SliderOptions.propTypes = {
  range: PropTypes.arrayOf(PropTypes.integer, PropTypes.integer),
  defaultValue: PropTypes.arrayOf(PropTypes.integer, PropTypes.integer),
};

function NumberInput({ value, onChange }) {
  const handleChange = (event) => {
    const inputValue = event.target.value;
    if (Number.isNaN(inputValue)) return onChange(0);
    if (inputValue.length > 3) return onChange(0);
    // Only allow numbers and limit the length to 3
    return onChange(Number(inputValue));
  };

  return (
    <TextField
      variant="outlined"
      size="small"
      value={value}
      onChange={handleChange}
      inputProps={{
        maxLength: 3,
        style: { width: '3ch' }, // Limits the width to roughly 3 characters
      }}
    />
  );
}

const SliderFilterPopover = ({ label, onApplyFilter, options }) => {
  const [value, setValue] = useState(options.defaultRange || [0, 90]);
  const { range } = options;
  const handleChange = (newValue) => {
    let adjValue = newValue;
    if (newValue[0] <= range[0]) adjValue = [range[0], newValue[1]];
    if (newValue[1] >= range[1]) adjValue = [newValue[0], range[1]];
    if (newValue[1] <= newValue[0]) adjValue = [newValue[0], newValue[0]];
    setValue(adjValue);
  };

  return (
    <BaseFilterPopover label={label} onApplyFilter={onApplyFilter} value={value}>
      <div style={{ padding: '16px', minWidth: '400px' }}>
        <Typography id="range-slider" gutterBottom>
          Range: {value[0]} - {value[1]}
        </Typography>
        <Box display="flex" alignItems="center" justifyContent="center" gap={4}>
          <Box>
            <NumberInput value={value[0]} onChange={(v) => handleChange([v, value[1]])} />
          </Box>
          <Box flexGrow={1}>
            <CustomSlider
              min={range[0]}
              max={range[1]}
              value={value}
              onChange={(e, nv) => handleChange(nv)}
              valueLabelDisplay="auto"
              aria-labelledby="range-slider"
              marks={[
                { value: range[0], label: `${range[0]}` },
                { value: range[1], label: `${range[1]}` },
              ]}
            />
          </Box>
          <Box>
            <NumberInput value={value[1]} onChange={(v) => handleChange([value[0], v])} />
          </Box>
        </Box>
      </div>
    </BaseFilterPopover>
  );
};

export default SliderFilterPopover;
